var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.969 -1.47206e-06C18.8108 0.00389466 18.6536 0.0250196 18.5 0.0629987L2.25 4.343C1.60769 4.51305 1.03926 4.88992 0.632576 5.41537C0.225888 5.94081 0.00357716 6.58557 0 7.25V21C0 22.645 1.355 24 3 24H21C22.645 24 24 22.645 24 21V8C24 6.355 22.645 5 21 5H7.625L19 2V4H21V2C21 0.874999 20.043 -0.0160015 18.969 -1.47206e-06ZM3 7H21C21.566 7 22 7.434 22 8V21C22 21.566 21.566 22 21 22H3C2.434 22 2 21.566 2 21V8C2 7.434 2.434 7 3 7ZM18.5 13C18.1022 13 17.7206 13.158 17.4393 13.4393C17.158 13.7206 17 14.1022 17 14.5C17 14.8978 17.158 15.2794 17.4393 15.5607C17.7206 15.842 18.1022 16 18.5 16C18.8978 16 19.2794 15.842 19.5607 15.5607C19.842 15.2794 20 14.8978 20 14.5C20 14.1022 19.842 13.7206 19.5607 13.4393C19.2794 13.158 18.8978 13 18.5 13Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletWhite);
export default __webpack_public_path__ + "static/media/wallet-white.9ef2d168779b696975a98cc77a5b7338.svg";
export { ForwardRef as ReactComponent };